import 'vue-awesome/icons/chevron-down';
import 'vue-awesome/icons/check';
import ProgressBar from '@/components/progress-bar/ProgressBar.vue';
import OfflineButton from '@/components/offline-button/OfflineButton.vue';
import OfflineMode from '@/components/offline-mode/OfflineMode.vue';
import offlineCheck from '@/mixins/offline-check';

export default {
  mixins: [offlineCheck],
  data() {
    return {
      language: null,
      availableLanguages: this.localeService.getLanguages(),
      famUrl: '#',
      navOpen: false,
    };
  },
  components: {
    'progress-bar': ProgressBar,
    'offline-button': OfflineButton,
    'offline-mode': OfflineMode,
  },
  dependencies: ['authService', 'localeService', 'publicConfigService', 'adApiService'],
  computed: {
    userFullName: function computeUserFullName() {
      let name = null;
      if (this.$store && this.$store.user) {
        if (this.$store.user.name || this.$store.user.surname) {
          name = `${this.$store.user.name || ''} ${this.$store.user.surname || ''}`.trim();
        }
        if (!name) {
          name = `${this.$store.user.email}`.trim();
        }
      }

      return name;
    },
    notLoggedIn() {
      return this.userFullName === null;
    },
    showLanguageSelector() {
      return this.availableLanguages && this.availableLanguages.length > 1;
    },
    offlineModeEnabled() {
      return false;
    },
  },
  methods: {
    logout() {
      this.authService.logout();
      this.closeNavigation();
    },
    localeSelect(locale) {
      if (locale !== this.language) {
        this.localeService.changeLocale(locale);
        if (this.$store && this.$store.user) {
          this.adApiService.updateUserProfile({ selected_language: locale });
        }
      }
    },
    closeNavigation() {
      this.$refs.headerNav.show = false;
    },
    getLanuageLink(code) {
      return `link_header_language_to_${code}`;
    },
  },
  mounted() {
    this.$root.$on('collapse::toggle::state', (id, value) => {
      if (this.$refs.headerNav && id === this.$refs.headerNav.$el.id) {
        this.navOpen = value;
      }
    });

    this.publicConfigService.getConfig()
      .then(config => config.rabbit.url || config.fam_url || '#')
      .then(famUrl => this.famUrl = famUrl);

    this.localeService.getUserLanguage().then(language => this.language = language);
    this.localeService.getEventBus().$on('language-changed', language => this.language = language);
  },
  updated() {
    Object.values(this.$el.getElementsByClassName('nav-item')).forEach(item => {
      Object.values(item.getElementsByTagName('a')).forEach(link => {
        let linkName = link.getAttribute('href').replace(/\//g, '_');
        if (linkName && linkName.length !== 0 && linkName !== '#') {
          if (linkName.startsWith('https:__rabbit.')) {
            linkName = '_fam_rabbit';
          }
          link.setAttribute('name', `link_header_to${linkName}`);
        }
      });
    });
  },
  beforeDestroy() {
    this.localeService.getEventBus().$off('language-changed', language => this.language = language);
  },
  watch: {
    $route() {
      if (this.navOpen) {
        this.closeNavigation();
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/header/Header.js